var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgCancelButton = (_ref, ref) => {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "17px",
    height: "16px",
    viewBox: "0 0 17 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "4B8449E0-DE7D-4128-8531-F46233D285D4") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "REIS_Wiregrame-V2",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "REIS_Add-Transaction-(overlay)",
    transform: "translate(-590.000000, -643.000000)",
    fill: "#000000",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Modal-Window/Radio-btn-+-CTA's/Radio-btn-+-CTA's",
    transform: "translate(359.489000, 368.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Round-Button/_Cancel/Cancel-Btn-Icon",
    transform: "translate(208.000000, 263.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Atoms/Chips/Chip-Remove-Button-Copy",
    transform: "translate(23.000000, 12.000000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Close-X",
    points: "16 14.7087719 14.7087719 16 7.99438596 9.28561404 1.28 16 0 14.7087719 6.71438596 7.99438596 0 1.28 1.28 0 7.99438596 6.71438596 14.7087719 0 16 1.28 9.28561404 7.99438596"
  }))))))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgCancelButton);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/CancelButton.ba1c2555c3dfb8d4ca2f07912d564cb5.svg";